import { Box, Button, Typography } from '@mui/material';
import { LocationEntity } from '@peritasai/repository';
import { ListCard } from '../../../shared';
import type { AssignToCaseSelectionLabels } from '../types/assign-to-case';
import {
  caseListScrollSx,
  listRowSx,
  locationHeadingSx,
  locationListRowContentSx,
  locationNameSx,
  selectButtonSx,
  selectHubLocationTitleSx,
} from './styles';

type LocationListCardProps = {
  locations: LocationEntity[];
  showAll: boolean;
  showViewAll: boolean;
  labels: AssignToCaseSelectionLabels;
  onToggleViewAll: () => void;
  onSelect: (location: LocationEntity) => void;
};

export const LocationListCard = ({
  locations,
  showAll,
  showViewAll,
  labels,
  onToggleViewAll,
  onSelect,
}: LocationListCardProps) => {
  const listHeight = showAll ? 'calc(100vh - 420px)' : 'auto';

  return (
    <ListCard
      sx={
        showAll
          ? {
              width: { xs: '450px', md: '100%' },
              maxWidth: { xs: '450px', md: '100%' },
              height: '750px',
              overflow: 'hidden',
              gap: { xs: '40px', md: '16px' },
              padding: { xs: '40px 32px', md: '24px' },
              alignItems: { xs: 'center', md: 'stretch' },
            }
          : {
              width: { xs: '450px', md: '100%' },
              maxWidth: { xs: '450px', md: '100%' },
              overflow: 'visible',
              gap: { xs: '40px', md: '16px' },
              padding: { xs: '40px 32px', md: '24px' },
              alignItems: { xs: 'center', md: 'stretch' },
            }
      }
      showViewAll={showViewAll}
      expanded={showAll}
      onToggleViewAll={onToggleViewAll}
      viewAllLabel={
        showAll
          ? labels.hideAdditionalLocationsLabel
          : labels.viewAllLocationsLabel
      }
    >
      <Box sx={locationHeadingSx}>
        <Typography sx={selectHubLocationTitleSx}>
          {labels.locationListTitle}
        </Typography>
      </Box>
      <Box
        sx={{
          ...caseListScrollSx(showAll, listHeight),
          scrollbarGutter: showAll ? 'stable' : 'auto',
        }}
      >
        {locations.map((location) => (
          <Box
            key={location.id}
            sx={listRowSx}
            onClick={() => onSelect(location)}
            role="button"
            tabIndex={0}
            onKeyDown={(event) => {
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                onSelect(location);
              }
            }}
          >
            <Box sx={locationListRowContentSx}>
              <Typography sx={locationNameSx}>{location.name}</Typography>
              <Button
                variant="contained"
                size="small"
                onClick={(event) => {
                  event.stopPropagation();
                  onSelect(location);
                }}
                sx={selectButtonSx}
              >
                {labels.selectButtonLabel}
              </Button>
            </Box>
          </Box>
        ))}
      </Box>
    </ListCard>
  );
};
